import { useFetchAllDiscountGroups } from '@retail/calculus/data-access';
import { useFetchAllSuppliers, useFetchBk04ProductGroups } from '@retail/products/data-access';
import { DiscountGroup, ProductGroupCount } from '@retail/products/types';
import { SupplierBase } from '@retail/suppliers/types';
import { useMemo } from 'react';

interface Props {
  selectedSupplierNumbers?: string[] | string;
  selectedProductGroupNumbers?: string[];
  selectedDiscountGroupCodes?: string[];
}

export function useFilterOptions({ selectedSupplierNumbers }: Props = {}) {
  const { data: suppliersDtos } = useFetchAllSuppliers({}, { suspense: false });
  const suppliers = useMemo(
    () => suppliersDtos?.map(SupplierBase.fromSupplierDTO) || [],
    [suppliersDtos]
  );

  const { data: discountGroupDtos = [] } = useFetchAllDiscountGroups({
    supplierIds: Array.isArray(selectedSupplierNumbers)
      ? selectedSupplierNumbers?.map((number) => Number(number))
      : selectedSupplierNumbers
      ? [Number(selectedSupplierNumbers)]
      : undefined,
    suspense: false,
  });
  const discountGroups = discountGroupDtos
    .map(DiscountGroup.fromDto)
    .sort((a, b) => `${a?.mgSupplierId} ${a?.code}`.localeCompare(`${b?.mgSupplierId} ${b?.code}`));

  const { data: bk04ProductGroupsDto = [] } = useFetchBk04ProductGroups({
    suspense: true,
  });
  const productGroupHierarchy = bk04ProductGroupsDto.map(ProductGroupCount.fromDto);
  const productGroups = ProductGroupCount.flatten(productGroupHierarchy);

  return {
    suppliers,
    discountGroups,
    productGroupHierarchy,
    productGroups,
  };
}
